import API_URLS from '@Constants/apiUrls.constants';
import {
  DataIntegrationResyncDnc,
  DataIntegrationResyncGlobalDnc,
} from '@Models/dnc.models';
import { baseApi } from '@Services/baseApi.service';

const {
  DATA_INTEGRATION: { PERSONAL_DNC, GLOBAL_DNC, GLOBAL_DNC_BULK },
} = API_URLS;

export const dataIntegrationApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['DataIntegration'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      updatePersonalDncToResync: builder.mutation<
        void,
        DataIntegrationResyncDnc
      >({
        query: ({ accountId, phones, dispositionName }) => ({
          url: PERSONAL_DNC,
          method: 'POST',
          body: {
            accountId,
            phones,
            dispositionName,
          },
        }),
      }),
      updateGlobalDncToResync: builder.mutation<
        void,
        DataIntegrationResyncGlobalDnc
      >({
        query: ({ phone, prevPhone }) => ({
          url: GLOBAL_DNC,
          method: 'POST',
          body: {
            phone,
            prevPhone,
          },
        }),
      }),
      deleteFromGlobalDncToResync: builder.mutation<void, string>({
        query: (phone: string) => ({
          url: `${GLOBAL_DNC}?phone=${encodeURIComponent(phone)}`,
          method: 'DELETE',
        }),
      }),
      bulkDeleteFromGlobalDncToResync: builder.mutation<void, string[]>({
        query: (phones: string[]) => ({
          url: GLOBAL_DNC_BULK,
          method: 'DELETE',
          body: {
            phones,
          },
        }),
      }),
    }),
  });

export const {
  useUpdatePersonalDncToResyncMutation,
  useUpdateGlobalDncToResyncMutation,
  useDeleteFromGlobalDncToResyncMutation,
  useBulkDeleteFromGlobalDncToResyncMutation,
} = dataIntegrationApi;
